import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Chip,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Category } from '@mui/icons-material';
import { faqJsonData } from '../../../json/faqJson';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // minWidth: '40%',
  minWidth: { xs: '70%', lg: '40%' },
  maxWidth: { xs: '70%', lg: '40%' },
  bgcolor: 'background.paper',
  // border: '1px solid #000',
  // boxShadow: 24,
  p: 2,
  borderRadius: 1,
  height: '90vh',
  overflow: 'scroll',
  overflowX: 'hidden'
};

export default function FrequentlyAskedQuestionsModal({ openAssignedModal, handleClose, setOpen }) {
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });
  const vertical = 'bottom';
  const horizontal = 'left';
  const [selectedFilter, setselectedFilter] = useState('general');

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  const handleClick = (value) => {
    setselectedFilter(value);
  };

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="faq-modal"
      >
        <Box sx={style} style={{ backgroundColor: '#F8FAFB' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography
              sx={{ fontSize: { xs: '16px', sm: '18px' }, fontWeight: 700, lineHeight: '17.57px' }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography sx={{ fontSize: { xs: '14px', sm: '16px' }, fontWeight: 500 }}>
              These are the most commonly asked questions about the Lockator. Can’t find what you’re
              looking for? Chat with our team here.
            </Typography>
          </Box>

          {/* <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 1, sm: 2 } }}>
            <Paper
              component="form"
              sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '426px',
                height: '50px',
                borderRadius: '10px',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)'
              }}
            >
              <IconButton sx={{ p: '10px' }}>
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: { xs: '12px', sm: '14px' } }}
                placeholder="Search here..."
                size="small"
              />
            </Paper>
          </Box> */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'center',
              gap: 1,
              mt: 3
            }}
          >
            <Chip
              onClick={() => handleClick('general')}
              label="General"
              color={selectedFilter === 'general' ? 'primary' : undefined}
              sx={{
                p: { xs: '4px 8px', sm: '6px 12px' },
                fontSize: { xs: '12px', sm: '14px' }
              }}
            />
            <Chip
              onClick={() => handleClick('unlocking')}
              label="Unlocking"
              color={selectedFilter === 'unlocking' ? 'primary' : undefined}
              sx={{
                p: { xs: '4px 8px', sm: '6px 12px' },
                fontSize: { xs: '12px', sm: '14px' }
              }}
            />
            <Chip
              onClick={() => handleClick('usermanagement')}
              label="User Management"
              color={selectedFilter === 'usermanagement' ? 'primary' : undefined}
              sx={{
                p: { xs: '4px 8px', sm: '6px 12px' },
                fontSize: { xs: '12px', sm: '14px' }
              }}
            />
          </Box>

          <Box sx={{ mt: 4 }}>
            {faqJsonData
              ?.filter((item) => item?.category === selectedFilter)
              ?.map((item) => (
                <Accordion key={item.index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${item.index}-content`}
                    id={`panel${item.index}-header`}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: { xs: '14px', sm: '16px' } }}>
                      {item.ques}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                      {item.ans}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            {/* {faqJsonData.map((item) => (
              <Accordion key={item.index}>
                <AccordionSummary
                  // sx={{ height: '60px' }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${item.index}-content`}
                  id={`panel${item.index}-header`}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: { xs: '14px', sm: '16px' } }}>
                    {item.ques}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>{item.ans}</Typography>
                </AccordionDetails>
              </Accordion>
            ))} */}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
